export Module from './Module';



// WEBPACK FOOTER //
// ./src/index.js